@if (fieldSet.includes(ServiceDataFields.Ivf)) {
  <ng-container formGroupName="inVitro">
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <div class="row align-items-center">
          <div class="col-12 col-sm-6 col-md-4 mb-1">
            <label for="isInVitroFertilized">{{
              'serviceData.form.isInVitroFertilized' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-6 col-md-8">
            <div class="form-check form-check-inline form-check-lg">
              <input
                class="form-check-input me-2"
                type="radio"
                formControlName="isInVitroFertilized"
                id="isInVitroFertilizedYes"
                [attr.data-cy]="ServiceDataFields.Ivf + '-radio-yes'"
                [value]="true"
              />
              <label class="form-check-label" for="isInVitroFertilizedYes">
                {{ 'common.yes' | translate }}
              </label>
            </div>
            <div class="form-check form-check-inline form-check-lg">
              <input
                id="isInVitroFertilizedNo"
                class="form-check-input me-2"
                type="radio"
                formControlName="isInVitroFertilized"
                [attr.data-cy]="ServiceDataFields.Ivf + '-radio-no'"
                [value]="false"
              />
              <label class="form-check-label" for="isInVitroFertilizedNo">
                {{ 'common.no' | translate }}
              </label>
            </div>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-12 col-sm-6 col-md-8">
            <app-validation-error
              for="isInVitroFertilized"
              translations="validation.generic"
              [attr.data-cy]="ServiceDataFields.Ivf + '-validation-error'"
            ></app-validation-error>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 mb-3">
        @if (form.get('inVitro.isInVitroFertilized').value) {
          <div class="row align-items-center">
            <div class="col-12 col-sm-4 mb-1">
              <label for="vitroType">{{
                'serviceData.form.vitroType' | translate
              }}</label>
            </div>
            <div class="col-12 col-sm-8">
              <app-select
                appInputValidationStatus
                id="vitroType"
                class="radio-toolbar"
                formControlName="vitroType"
                [attr.data-cy]="ServiceDataFields.Ivf + 'Type-select'"
                [placeholder]="
                  'serviceData.form.placeholders.vitroType' | translate
                "
              >
                @for (type of Object.keys(InVitroTypes); track type) {
                  <app-select-option
                    [value]="type"
                    [label]="'serviceData.form.inVitro.' + type | translate"
                  />
                }
              </app-select>
            </div>
          </div>
          <div class="row justify-content-end">
            <div class="col-12 col-sm-8">
              <app-validation-error
                for="vitroType"
                translations="validation.generic"
                [attr.data-cy]="ServiceDataFields.Ivf + 'Type-validation-error'"
              ></app-validation-error>
            </div>
          </div>
        }
      </div>
    </div>
    @if (form.get('inVitro.isInVitroFertilized').value) {
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <div class="row align-items-center">
            <div class="col-12 col-sm-6 col-md-4 mb-1">
              <label for="isSurrogateMother">{{
                'serviceData.form.isSurrogateMother' | translate
              }}</label>
            </div>
            <div class="col-12 col-sm-6 col-md-8">
              <div class="col-9">
                <div class="form-check form-check-inline form-check-lg">
                  <input
                    class="form-check-input me-2"
                    type="radio"
                    formControlName="isSurrogateMother"
                    [attr.data-cy]="
                      ServiceDataFields.Ivf + 'Surrogate-radio-yes'
                    "
                    [value]="true"
                  />
                  <label class="form-check-label" for="isSurrogateMotherYes">
                    {{ 'common.yes' | translate }}
                  </label>
                </div>
                <div class="form-check form-check-inline form-check-lg">
                  <input
                    class="form-check-input me-2"
                    type="radio"
                    formControlName="isSurrogateMother"
                    [attr.data-cy]="
                      ServiceDataFields.Ivf + 'Surrogate-radio-no'
                    "
                    [value]="false"
                  />
                  <label class="form-check-label" for="isSurrogateMotherNo">
                    {{ 'common.no' | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-end">
            <div class="col-12 col-sm-6 col-md-8">
              <app-validation-error
                for="isSurrogateMother"
                translations="validation.generic"
                [attr.data-cy]="
                  ServiceDataFields.Ivf + 'Surrogate-validation-error'
                "
              ></app-validation-error>
            </div>
          </div>
        </div>
      </div>
    }
  </ng-container>
}
